// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/folder-pen.js';

import { paths } from '../generated/folder-pen';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('folder-pen', Original, paths);
